<template>
  <b-tabs
    v-if="entity.id"
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <b-tab active>
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('General') }}</span>
      </template>

      <account-setting-general
        ref="general"
        :user-data="entity"
        @formSubmitted="submitForm"
      />
    </b-tab>

    <b-tab>
      <template #title>
        <feather-icon
          icon="InfoIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Contact Information') }}</span>
      </template>

      <account-setting-information
        ref="info"
        :user-data="entity"
        @formSubmitted="submitForm"
      />
    </b-tab>

    <b-tab>
      <template #title>
        <feather-icon
          icon="BriefcaseIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Job Details') }}</span>
      </template>

      <account-setting-job
        ref="info"
        :user-data="entity"
        @formSubmitted="submitForm"
      />
    </b-tab>

    <b-tab>
      <template #title>
        <feather-icon
          icon="LinkIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Links') }}</span>
      </template>

      <account-setting-links
        ref="info"
        :user-data="entity"
        @formSubmitted="submitForm"
      />
    </b-tab>

    <!-- change password tab -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('change password') }}</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <b-tab>
      <template #title>
        <feather-icon
          icon="SlidersIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Subscriptions') }}</span>
      </template>

      <subscriptions-grid />
    </b-tab>

    <b-tab>
      <template #title>
        <feather-icon
          icon="MailIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Newsletter') }}</span>
      </template>

      <account-setting-newsletter :user-data="entity" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'

import SubscriptionsGrid from '@/views/subscriptions/SubscriptionsGrid.vue'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingInformation from './AccountSettingInformation.vue'
import AccountSettingNewsletter from './AccountSettingNewsletter.vue'
import AccountSettingJob from './AccountSettingJob.vue'
import AccountSettingLinks from './AccountSettingLinks.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    AccountSettingNewsletter,
    AccountSettingJob,
    AccountSettingLinks,
    SubscriptionsGrid,
  },
  data() {
    return {
      entity: {},
    }
  },
  async mounted() {
    this.entity = (await this.$store.dispatch('app-common/getUser')).data
  },
  methods: {
    submitForm(entity) {
      this.entity = entity
      this.$store
        .dispatch('app-common/updateUserData', entity)
        .then(() => {
          this.reloadData()
          this.showToast({
            title: this.$t('Entity Saved'),
            icon: 'EditIcon',
            variant: 'success',
            text: this.$t('Save completed successfully'),
          })
        })
        .catch(() => {
          this.showToast({
            title: this.$t('Something went wrong!'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          })
        })
    },
    reloadData() {
      this.$refs.general.reloadData()
      this.$refs.info.reloadData()
    },
  },
}
</script>
